import { shiftList } from "constants/shift";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const getShiftList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.get_shift_list(pageNum, filters);
    dispatch({ type: shiftList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: shiftList,
      payload: error?.response?.data || error,
    });
  }
};
